import React from "react";

const AnimatedBackground:React.FC<{children: React.ReactNode}>=({children})=>{
  return (
     <div style={{
            position: 'relative',
            minHeight: '100vh',
          //  background: 'linear-gradient(135deg, #1E3A5F 0%, #0F1E2E 100%)',
           background: "radial-gradient(circle at 50% -20%, #1e293b, #0f172a, #070a12)",
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            {/* Animated Pulse Circles */}
            <div style={{
                position: 'absolute',
                top: '10%',
                right: '10%',
                width: 250,
                height: 250,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                animation: 'pulse 4s ease-in-out infinite',
                pointerEvents: 'none'
            }} />
            
            <div style={{
                position: 'absolute',
                bottom: '15%',
                left: '10%',
                width: 200,
                height: 200,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                animation: 'pulse 4s ease-in-out infinite 1s',
                pointerEvents: 'none'
            }} />

            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                height: 400,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.03)',
                animation: 'pulse 6s ease-in-out infinite 0.5s',
                pointerEvents: 'none'
            }} />

            {/* Floating Particles */}
            <div style={{
                position: 'absolute',
                top: '20%',
                left: '15%',
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.3)',
                animation: 'float 6s ease-in-out infinite'
            }} />
            
            <div style={{
                position: 'absolute',
                top: '70%',
                right: '20%',
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.4)',
                animation: 'float 5s ease-in-out infinite 1s'
            }} />

            <div style={{
                position: 'absolute',
                top: '40%',
                right: '15%',
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.2)',
                animation: 'float 7s ease-in-out infinite 2s'
            }} />

            <div style={{
                position: 'absolute',
                bottom: '25%',
                right: '40%',
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.4)',
                animation: 'float 8s ease-in-out infinite 0.5s'
            }} />

            {/* Animations */}
            <style>{`
                @keyframes pulse {
                    0%, 100% { 
                        transform: scale(1); 
                        opacity: 0.5; 
                    }
                    50% { 
                        transform: scale(1.2); 
                        opacity: 0.2; 
                    }
                }
                
                @keyframes float {
                    0%, 100% { 
                        transform: translateY(0) translateX(0); 
                        opacity: 0.6;
                    }
                    25% { 
                        transform: translateY(-20px) translateX(10px); 
                        opacity: 1;
                    }
                    50% { 
                        transform: translateY(-40px) translateX(-10px); 
                        opacity: 0.8;
                    }
                    75% { 
                        transform: translateY(-20px) translateX(15px); 
                        opacity: 1;
                    }
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>

            {/* Content (Children) */}
            <div style={{
                position: 'relative',
                zIndex: 10,
                width: '100%',
                animation: 'fadeInUp 0.8s ease-out'
            }}>
                {children}
            </div>
        </div>
  )
}
export default AnimatedBackground;